var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ButtonComponent',{attrs:{"theme":_vm.theme,"label":_vm.label,"icon":_vm.icon},on:{"click":function($event){return _vm.$bus.$emit('task', { reference: _vm.reference })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }